import React from "react";
import Box from "../../ui/box/Box";
import Field from "../../ui/form/Field";
import {OrderFormInterface} from "./OrderFormInterface";

interface MessageFormInterface extends OrderFormInterface {}

export function MessageForm({formik, colXs, colSm}: MessageFormInterface) {
    return (
        <>
            <Box
                boxXs={colXs}
                boxSm={colSm}
                boxName={'message'}
                headerClassNames={'rounded-top'}
                header={true}
                headerTextColor={'white'}
                headerContent={
                    <h3 className="my-auto">Message</h3>
                }
                headerPadding={'p-3'}
                boxContentPadding={'p-3'}
                content={
                    <>
                        <Field
                            id={'message'}
                            name={'message'}
                            label={'Message'}
                            as={'textarea'}
                            rows={5}
                            value={formik.values.message}
                            onChange={formik.handleChange}
                        />
                    </>
                }
            />
        </>
    );
}
